import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
  Box,
  Grid,
  IconButton,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  Avatar,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import { ReactComponent as Download } from "../../../../../assets/invoice/material-symbols_download.svg";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";
import styles from "./style";
import profile from "../../../../../assets/images/female.png";
import color from "../../../../../constants/color";
import { getDateFormat } from "../../../../../utils/dateFormatStore";

const RecurringTemplatePage = ({ recurringTemplateDetail, childInvoices }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);


  return (
    <>
      <Box px="15px" mt={2}>
        <Typography sx={styles.leaveHeading}>Recurring Invoice</Typography>
      </Box>
      <Grid container sx={styles.gridContainer}>
        <Grid item xs={12} lg={12} sx={styles.templateDetails}>
          <Box sx={{ ...styles.templateDetails, width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                gap: 7,
                width: "100%",
              }}
            >
              <Box
                sx={{ display: "flex", gap: 2, alignItems: "center", pl: 3 }}
              >
                <Avatar src={profile} sx={styles.avatar}></Avatar>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                >
                  <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
                    {recurringTemplateDetail?.customer?.name}
                  </Box>
                  <Box
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: color.primary,
                    }}
                  >
                    {recurringTemplateDetail?.customer?.email}
                  </Box>
                  <Box sx={{ color: color.lightText }}>
                    {recurringTemplateDetail?.customer?.phone}
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexGrow: 1, mr: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Box sx={{ p: 0.7, fontWeight: 600 }}>Details</Box>
                  <Box sx={{ display: "flex" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        width: "50%",
                      }}
                    >
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ width: "50%", p: 0.7, fontWeight: 600 }}>
                          Profile Status:
                        </Box>
                        <Box sx={{ width: "50%", p: 0.7 }}>
                          {recurringTemplateDetail?.status}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ width: "50%", p: 0.7, fontWeight: 600 }}>
                          Start Date:
                        </Box>
                        <Box
                          sx={{ width: "50%", p: 0.7, color: color.lightText }}
                        >
                          {dayjs(recurringTemplateDetail?.startOn).format(
                            "YYYY-MM-DD"
                          )}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ width: "50%", p: 0.7, fontWeight: 600 }}>
                          End Date:
                        </Box>
                        <Box
                          sx={{ width: "50%", p: 0.7, color: color.lightText }}
                        >
                          {dayjs(recurringTemplateDetail?.endOn).format(
                            "YYYY-MM-DD"
                          )}
                        </Box>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        width: "50%",
                      }}
                    >
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ width: "50%", p: 0.7, fontWeight: 600 }}>
                          Order Number:
                        </Box>
                        <Box
                          sx={{ width: "50%", p: 0.7, color: color.lightText }}
                        >
                          001
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ width: "50%", p: 0.7, fontWeight: 600 }}>
                          Payment Terms:
                        </Box>
                        <Box
                          sx={{ width: "50%", p: 0.7, color: color.lightText }}
                        >
                          {recurringTemplateDetail?.paymentTerms}
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ width: "50%", p: 0.7, fontWeight: 600 }}>
                          Manually Created:
                        </Box>
                        <Box
                          sx={{ width: "50%", p: 0.7, color: color.lightText }}
                        >
                          1
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{ width: "100%", px: 3, fontSize: "18px", fontWeight: 600 }}
            >
              Address:
            </Box>
            <Box sx={{ display: "flex", gap: 3, width: "100%", px: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  flexGrow: 1,
                }}
              >
                <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
                  Billing Address
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "2px" }}
                >
                  <Box>{recurringTemplateDetail?.billingAddress?.street1}</Box>
                  <Box>{recurringTemplateDetail?.billingAddress?.street2}</Box>
                  <Box>
                    {recurringTemplateDetail?.billingAddress?.city},{" "}
                    {recurringTemplateDetail?.billingAddress?.state}
                  </Box>
                  <Box>
                    {recurringTemplateDetail?.billingAddress?.country},{" "}
                    {recurringTemplateDetail?.billingAddress?.pinCode}
                  </Box>
                  <Box>Email: {recurringTemplateDetail?.customer?.email}</Box>
                  <Box>
                    Phone: {recurringTemplateDetail?.billingAddress?.phone}
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  flexGrow: 1,
                }}
              >
                <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
                  Shipping Address
                </Box>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "2px" }}
                >
                  <Box>{recurringTemplateDetail?.shippingAddress?.street1}</Box>
                  <Box>{recurringTemplateDetail?.shippingAddress?.street2}</Box>
                  <Box>
                    {recurringTemplateDetail?.shippingAddress?.city},{" "}
                    {recurringTemplateDetail?.shippingAddress?.state}
                  </Box>
                  <Box>
                    {recurringTemplateDetail?.shippingAddress?.country},{" "}
                    {recurringTemplateDetail?.shippingAddress?.pinCode}
                  </Box>
                  <Box>Email: {recurringTemplateDetail?.customer?.email}</Box>
                  <Box>
                    Phone: {recurringTemplateDetail?.shippingAddress?.phone}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          backgroundColor: theme.palette.white.main,
          m: 2,
          borderRadius: "20px",
          mb: 5,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-around" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              my: 3,
              gap: 0.5,
            }}
          >
            <Box sx={{ fontSize: "18px", fontWeight: 600 }}>Invoice Amount</Box>
            <Box
              sx={{ color: color.lightText, fontSize: "17px", fontWeight: 500 }}
            >
              ${recurringTemplateDetail?.grandTotal}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              my: 3,
              gap: 0.5,
            }}
          >
            <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
              Next Invoice Date
            </Box>
            <Box
              sx={{ color: color.lightText, fontSize: "17px", fontWeight: 500 }}
            >
              {dayjs(recurringTemplateDetail?.nextTriggerDate).format(
                "YYYY-MM-DD"
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              my: 3,
              gap: 0.5,
            }}
          >
            <Box sx={{ fontSize: "18px", fontWeight: 600 }}>
              Recurring Period
            </Box>
            <Box
              sx={{ color: color.lightText, fontSize: "17px", fontWeight: 500 }}
            >
              {recurringTemplateDetail?.repeatEvery}
            </Box>
          </Box>
        </Box>
        <Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={styles.TableHead}>Date</TableCell>
                  <TableCell sx={styles.TableHead}>Invoice #</TableCell>
                  <TableCell sx={styles.TableHead}>Customer Name</TableCell>
                  <TableCell sx={styles.TableHead}>Due Date</TableCell>
                  <TableCell sx={styles.TableHead}>Amount</TableCell>
                  <TableCell sx={styles.TableHead}>Status</TableCell>
                  {/* <TableCell sx={styles.TableHead}>Action</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {childInvoices.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  childInvoices
                    .slice((page - 1) * rowsPerPage, page * rowsPerPage)
                    .map((item) => (
                      <TableRow
                        key={item._id}
                        hover
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate("/dashboard/viewInvoice", { state: { item, page } })
                        }}
                      >
                        <TableCell sx={styles.tabledata}>
                          {dayjs(item?.invoiceDate).format(getDateFormat())}
                        </TableCell>
                        <TableCell sx={styles.tabledata}>
                          #{item?.invoiceNo}
                        </TableCell>
                        <TableCell sx={styles.tabledata}>
                          {recurringTemplateDetail?.customer?.name}
                        </TableCell>
                        <TableCell sx={styles.tabledata}>
                          {dayjs(item?.dueDate).format(getDateFormat())}
                        </TableCell>
                        <TableCell sx={styles.tabledata}>
                          {item?.grandTotal.toFixed(2)}
                        </TableCell>
                        <TableCell sx={{ borderBottom: 0 }}>
                          <Box
                            sx={{
                              border: `1px solid ${
                                item.status === "Paid"
                                  ? "#28AA4A"
                                  : item.status === "Sent"
                                  ? "#00ABF4"
                                  : item.status === "Draft"
                                  ? "#F4B63F"
                                  : "black"
                              }`,
                              borderRadius: "30px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              py: "3px",
                              px: "14px",
                              width: "fit-content",
                              fontSize: "12px",
                              color: `${
                                item.status === "Paid"
                                  ? "#28AA4A"
                                  : item.status === "Sent"
                                  ? "#00ABF4"
                                  : item.status === "Draft"
                                  ? "#F4B63F"
                                  : "black"
                              }`,
                            }}
                          >
                            {item?.status}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                )}
              </TableBody>
            </Table>

            <CustomPagination
              pageCount={Math.ceil(childInvoices.length / rowsPerPage)}
              totalItems={childInvoices.length}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};
export default RecurringTemplatePage;
